export default __webpack_public_path__ + "static/media/edit_icon_black.84cbf2b8.svg";